import httpRequest from '@/utils/request'

export { getHongKongTrades, getHongKongIndustries, getHongKongBoard } from '@/utils/hongKongQuotes'
export const getHongKongContracts = page => httpRequest({ url: 'vexe/v1/contract/contractList', method: 'get', params: { status: 0, mkt_type: 1, page } })
export const getHongKongPositionStatus = params => httpRequest({ url: 'vexe/v1/contract/positionOperStatus', method: 'get', params })
export const submitHongKongOrder = (side, data) => httpRequest({ url: `vexe/v1/contract_order/${side === 'sell' ? 'sell' : 'buy'}`, method: 'post', data, successMessage: '委托成功' })

export const getHongKongIndustryStocks = code => httpRequest({
  url: 'vexe/v1/stock/stockGGHot',
  method: 'post',
  data: { code, plate: 400, rank: 1 }
})

export const getHongKongRank = () => httpRequest({
  url: 'vexe/v1/stock/stockGGRank',
  method: 'get'
})

export const getHongKongMarketSummary = () => httpRequest({
  url: 'vexe/v1/stock/gGTodayGs',
  method: 'get'
})
